'use client';

import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
const defaultContextValue = (props) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content -- should be handled by Chalk components implemented with this quark
  /* @__PURE__ */ jsx("a", { ...props })
);
const CustomAnchorContext = createContext(defaultContextValue);
const CustomAnchorProvider = CustomAnchorContext.Provider;
export {
  CustomAnchorContext,
  CustomAnchorProvider
};
